module.exports = __webpack_public_path__ + "img/BOŚ Bank .dd217a0c.png";